import { MapPin } from "lucide-react";

const locations = [
  "Murtal – Murau",
  "Murtal – Leoben",
  "Murtal – Graz",
  "Murtal – Kapfenberg",
  "Murtal – Klagenfurt",
];

export const Coverage = () => {
  return (
    <section className="section-pad bg-background">
      <div className="container-narrow">
        <div className="mb-12 text-center">
          <span className="eyebrow text-secondary">Wo wir tätig sind</span>
          <h2 className="h2-display mt-3 text-primary">Unser Einsatzgebiet</h2>
          <span className="gold-underline" />
          <p className="mx-auto mt-6 max-w-2xl body-base text-muted-foreground">
            Wir sind in der gesamten Region Murtal und den umliegenden Bezirken für
            Sie im Einsatz — bei Bedarf koordinieren wir auch Aufträge außerhalb
            dieser Gebiete. Sprechen Sie uns einfach an.
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3">
          {locations.map((loc) => (
            <span
              key={loc}
              className="inline-flex items-center gap-2 rounded-full px-5 py-2 text-[14px] font-medium transition-colors hover:bg-secondary hover:text-white"
              style={{
                border: "1.5px solid hsl(var(--secondary))",
                color: "hsl(var(--secondary))",
                borderRadius: 100,
              }}
            >
              <MapPin className="h-4 w-4" />
              {loc}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
